import {
    MergeFieldsReturnData
} from '@dev/ee-api/ee-api-models';

import { AxiosPromise } from 'axios';

import { request } from './request';

export const getMergeField = (): AxiosPromise<MergeFieldsReturnData> => {
    const { MergeField } = request();
    return MergeField.mergefieldGet();
};
